exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hoverItem[data-v-7b0d76e0] {\n  cursor: pointer;\n}\n.container-main-db[data-v-7b0d76e0] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n          justify-content: space-between;\n}\n@media (max-width: 1220px) {\n.container-main-db[data-v-7b0d76e0] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n            flex-direction: column;\n    -webkit-box-align: center;\n            align-items: center;\n    margin-bottom: 70px;\n}\n}\n\n", ""]);

// exports
